import { useId } from '@radix-ui/react-id'
import { Icon } from 'components/Icon'
import { useTranslation } from 'hooks/useTranslation'
import { FEEDING_TYPES, FeedingType, getPillLabel } from '../feedingContent'
import {
  Eyebrow,
  FeedingPillSelectorRoot,
  Headline,
  PillGrid,
  PillInput,
  PillOption,
  PillRow,
} from './FeedingPillSelector.styles'

const PILL_ROWS: FeedingType[][] = [
  [FEEDING_TYPES[0]],
  [FEEDING_TYPES[1]],
  [FEEDING_TYPES[2], FEEDING_TYPES[3]],
  [FEEDING_TYPES[4], FEEDING_TYPES[5]],
  [FEEDING_TYPES[6]],
]

type FeedingPillSelectorProps = {
  selected: FeedingType | null
  onSelect: (type: FeedingType) => void
  headingId: string
  hideEyebrow?: boolean
}

export const FeedingPillSelector = ({
  selected,
  onSelect,
  headingId,
  hideEyebrow,
}: FeedingPillSelectorProps) => {
  const { t } = useTranslation()
  const groupName = useId()

  return (
    <FeedingPillSelectorRoot>
      {!hideEyebrow && <Eyebrow>{t('blog:currently-feeding.eyebrow')}</Eyebrow>}
      <Headline id={headingId}>{t('blog:currently-feeding.headline')}</Headline>
      <PillGrid role="radiogroup" aria-labelledby={headingId}>
        {PILL_ROWS.map((row) => (
          <PillRow key={row.join('-')}>
            {row.map((type) => {
              const inputId = `${groupName}-${type}`
              return (
                <PillOption key={type}>
                  <PillInput
                    id={inputId}
                    type="radio"
                    name={groupName}
                    value={type}
                    checked={selected === type}
                    onChange={() => onSelect(type)}
                  />
                  <label htmlFor={inputId}>
                    {selected === type && (
                      <Icon name="check" size="2" />
                    )}
                    {getPillLabel(t, type)}
                  </label>
                </PillOption>
              )
            })}
          </PillRow>
        ))}
      </PillGrid>
    </FeedingPillSelectorRoot>
  )
}
